import { post } from '../utils/api';

export const resetAffordaPortalApplication = async ({
  organizationId,
  propertyId,
  portalUserId,
  applicationId,
}) => {
  if (!portalUserId) {
    throw new Error('portalUserId is required');
  }

  if (!applicationId) {
    throw new Error('applicationId is required');
  }

  const url = `/${organizationId}/${propertyId}/afforda-portal-forms/${portalUserId}/reset`;
  const payload = { applicationId };

  try {
    // Ensure the payload is properly stringified
    const response = await post(url, JSON.stringify(payload));

    if (response.error) {
      throw new Error(response.error.message || 'Failed to reset application');
    }

    return response;
  } catch (error) {
    throw error;
  }
};
